'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = undefined;

var _assign = require('babel-runtime/core-js/object/assign');

var _assign2 = _interopRequireDefault(_assign);

var _stringify = require('babel-runtime/core-js/json/stringify');

var _stringify2 = _interopRequireDefault(_stringify);

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _Base = require('./Base');

var _Base2 = _interopRequireDefault(_Base);

var _options = require('../common/options');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var MiniBarComponent = function (_BaseComponent) {
    (0, _inherits3.default)(MiniBarComponent, _BaseComponent);

    function MiniBarComponent(props) {
        (0, _classCallCheck3.default)(this, MiniBarComponent);
        return (0, _possibleConstructorReturn3.default)(this, (MiniBarComponent.__proto__ || (0, _getPrototypeOf2.default)(MiniBarComponent)).call(this, props));
    }

    /**
     * 矫正 option
     */


    (0, _createClass3.default)(MiniBarComponent, [{
        key: 'packageOption',
        value: function packageOption() {
            var option = JSON.parse((0, _stringify2.default)((0, _assign2.default)({}, _options.MiniBarOption)));
            var _props = this.props,
                color = _props.color,
                hasTooltip = _props.hasTooltip,
                animation = _props.animation,
                data = _props.data;

            var xData = [];
            var yData = [];
            option.tooltip.show = hasTooltip;
            if (color && color.length) {
                option.color = color;
            }
            option.animation = animation;
            if (data && data.length) {
                data.forEach(function (obj) {
                    xData.push(obj.x);
                    yData.push(obj.y);
                });
                option.xAxis.data = xData;
                option.series = {
                    type: 'bar',
                    data: yData
                };
            }

            return option;
        }
    }]);
    return MiniBarComponent;
}(_Base2.default);

exports.default = MiniBarComponent;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./node_modules/_@alicd_crui-chart@0.0.14@@alicd/crui-chart/lib/components/MiniBar.js
// module id = 610
// module chunks = 0